import { ArticleDataContext } from 'articleEditor/contexts/articleDataProvider';
import { useContext } from 'react';
import { useLocation } from 'react-router-dom';

export function useCollectionId(): string | null {
  const { parentCollections } = useContext(ArticleDataContext);
  const { search } = useLocation();

  const collectionId = new URLSearchParams(search).get('collectionId');
  if (collectionId) return collectionId;

  if (!parentCollections || parentCollections.length === 0) return null;
  return parentCollections[0].id;
}
